import { eventBus } from "@/js/app";

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
export const shuffle = a => {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
};

export const replaceString = (oldString, newString, fullString) => {
    // replace oldString for newString in fullString

    for (var i = 0; i < fullString.length; i++) {
        if (fullString.substring(i, i + oldString.length) == oldString) {
            fullString =
                fullString.substring(0, i) +
                newString +
                fullString.substring(i + oldString.length, fullString.length);
        }
    }
    return fullString;
};

export const orderArrayPacks = (array) => {
    return array && array.slice().sort((a,b) => (parseFloat(a.pivot.final_price) > parseFloat(b.pivot.final_price)) ? 1 : ((parseFloat(b.pivot.final_price) > parseFloat(a.pivot.final_price)) ? -1 : 0))
}

export const orderArrayPacksBySeedPrice = (array) => {
    return array && array.slice().sort((a,b) => (parseFloat(a.pivot.seed_price) > parseFloat(b.pivot.seed_price)) ? 1 : ((parseFloat(b.pivot.seed_price) > parseFloat(a.pivot.seed_price)) ? -1 : 0))
}

export const orderArrayPacksByDiscount = (array) => {
    const discounts = array && array.filter((pack) => pack.pivot.discount !== null).map((pack) => parseFloat(pack.pivot.discount));
    return Math.max(...discounts); 
}

export const isCanarias = (postalCode) => {
    const { canariasCodes } = require('./postalCodes');

    return canariasCodes.includes(Number(postalCode));
}